module.exports = __webpack_public_path__ + "img/UTANTE-5.341ecfff.jpg";